// Security utilities
export const hashPassword = async (password) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password + 'iffa-salt-2024');
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const validateAdminAccess = () => {
  const authTime = localStorage.getItem('adminAuthTime');
  const isAuth = localStorage.getItem('adminAuth');
  
  if (!isAuth || !authTime) return false;
  
  // Session expires after 2 hours
  const sessionDuration = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
  const currentTime = Date.now();
  
  if (currentTime - parseInt(authTime) > sessionDuration) {
    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminAuthTime');
    return false;
  }
  
  return true;
};

export const setAdminAuth = () => {
  localStorage.setItem('adminAuth', 'true');
  localStorage.setItem('adminAuthTime', Date.now().toString());
};

export const clearAdminAuth = () => {
  localStorage.removeItem('adminAuth');
  localStorage.removeItem('adminAuthTime');
};

// Rate limiting for login attempts
const loginAttempts = new Map();

export const checkRateLimit = (ip = 'default') => {
  const now = Date.now();
  const attempts = loginAttempts.get(ip) || [];
  
  // Remove attempts older than 15 minutes
  const recentAttempts = attempts.filter(time => now - time < 15 * 60 * 1000);
  
  // Allow max 5 attempts per 15 minutes
  if (recentAttempts.length >= 5) {
    return false;
  }
  
  recentAttempts.push(now);
  loginAttempts.set(ip, recentAttempts);
  return true;
};